import TopicsPage from "@/pages/_topics";
import { defineMessage, useIntl } from "react-intl";
import ErrorPage from "@/pages/_error";
import ForumHelmet from "@/components/ForumHelmet";
import { graphql, Environment } from "react-relay";
import { LoaderArgs } from "@/utils/route";
import { EventTopicsPageQuery as EventTopicsPageQueryType } from "./__generated__/EventTopicsPageQuery.graphql";
import { preload, usePreloaded } from "@/utils/relay";
import { getVotableOrderParam } from "@/utils/votableOrder";
export default function EventTopicsPage() {
  const {
    query,
    variables: { order: initialOrder },
  } = useEventTopicsPageQuery();
  const forum = query?.eventBySlug?.forum;
  const intl = useIntl();
  if (!forum) {
    return (
      <ErrorPage
        status={404}
        message={intl.formatMessage({ defaultMessage: "Event not found" })}
      />
    );
  }
  return (
    <ForumHelmet forum={forum} parent={query.eventBySlug.slug}>
      <TopicsPage
        forum={query?.eventBySlug?.forum}
        initialOrder={initialOrder}
        parent={query.eventBySlug.slug}
      />
    </ForumHelmet>
  );
}
const EventTopicsPageQuery = graphql`
  query EventTopicsPageQuery($slug: String!, $order: VotableOrder!) {
    eventBySlug(slug: $slug) {
      slug
      forum {
        ...TopicsPageFragment @arguments(order: $order)
        ...ForumHelmetFragment
      }
    }
  }
`;
export const loader = (environment: Environment) => {
  return ({ params: { slug }, request }: LoaderArgs) => {
    const order = getVotableOrderParam(request) || "NEWEST";
    if (!slug) {
      throw new Response("No slug", { status: 500 });
    }
    return preload<EventTopicsPageQueryType>(
      environment,
      EventTopicsPageQuery,
      {
        slug,
        order,
      },
    );
  };
};
const useEventTopicsPageQuery = () => usePreloaded<EventTopicsPageQueryType>();

export const lazyHandle = {
  titleI18n: defineMessage({ defaultMessage: "Discussions" }),
};
